// frontend/src/constants/storagePaths.js

const BASE_PATH = 'Excelent love ministries personels';

export const STORAGE_PATHS = {
  ANNOUNCEMENTS: `${BASE_PATH}/announcements`,
  EVENTS: `${BASE_PATH}/events`,
  LEADERS: `${BASE_PATH}/leaders`,
  VIDEOS: `${BASE_PATH}/videos`,
  LOGOS: `${BASE_PATH}/logos`,
  // You can add more specific paths if needed
  MINISTRY_LOGOS: `${BASE_PATH}/logos`,
  MINISTRY_COVERS: `${BASE_PATH}/logos`, // Both using logos folder as per your structure
};

// Helper function to get full storage path
export const getStoragePath = (category) => {
  return STORAGE_PATHS[category.toUpperCase()] || `${BASE_PATH}/${category}`;
};

export default STORAGE_PATHS;